/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_ADDNEWUSER,ADDNEWUSER_RECEIVED } = constants.AddNewUserConstants;

export default {
    REQUEST_ADDNEWUSER,
    ADDNEWUSER_RECEIVED,

  requestAddNewUser: payload => ({
    type: REQUEST_ADDNEWUSER,
    payload
  }),
  AddNewUserReceived: () => ({
    type: ADDNEWUSER_RECEIVED
  }),
};
